import MembershipLevelBadge from '@/components/@next/MembershipLevelBadge/MembershipLevelBadge';
import UserVerificationLevelBadge from '@/components/@next/UserVerificationLevelBadge/UserVerificationLevelBadge';
import { UserShowcaseSearchDto } from '@/types';
import { getProfilePhoto } from '@/utils/profilePhoto';
import { IoMdStar } from 'react-icons/io';

interface ShowcaseCardProps {
  showcase: UserShowcaseSearchDto;
  onClick: () => void;
}

const ShowcaseCard = ({ showcase, onClick }: ShowcaseCardProps) => (
  <div onClick={onClick} className="rounded-lg shadow-md cursor-pointer">
    <div className="h-64 rounded-t-lg overflow-hidden relative">
      <img
        src={showcase.profileBanner ?? '/images/checkBackground.png'}
        alt="showcase-cover"
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 to-transparent rounded-t-lg" />
      <div className="flex items-center justify-between absolute top-3 left-6 right-6 z-10">
        <div>
          <MembershipLevelBadge user={showcase} />
        </div>

        <div className="flex items-center gap-x-2 text-white">
          <IoMdStar size={18} />

          <span>
            {showcase.rating} <span className="text-sm">{`(${showcase.ratedCount})`}</span>
          </span>
        </div>
      </div>
    </div>

    <div className="bg-white rounded-b-lg">
      <div className="flex items-end gap-x-4 px-6 relative -top-7">
        <div className="bg-white rounded-lg h-24 w-24 p-1.5 shadow-lg shrink-0">
          <img
            src={getProfilePhoto(showcase, 'original')}
            alt="showcase-image"
            className="w-full h-full rounded object-cover"
          />
        </div>

        <div className="flex flex-1 flex-col items-start py-2 truncate">
          <div className="flex items-center gap-x-1 max-w-full">
            <span className="block font-bold capitalize max-w-full truncate">
              {showcase.userName}
            </span>
            <UserVerificationLevelBadge user={showcase} />
          </div>
          <span className="text-sm text-gray-8a">
            {showcase.itemsCount} items │ {showcase.followersCount} followers
          </span>
        </div>
      </div>
    </div>
  </div>
);

export default ShowcaseCard;
